﻿import jquery from 'jquery';
import HabEvents from '../../../Global/habitaclia-events';

class FavoritosRateCommentDesktopUI {

    /* jshint ignore:start */
    constructor(favoritoRateCommentDto, favoritosService) {

        const selectors = {
            favorito: '.favlink',
            addComment: '.js-add-comment',
            addCommentContainer: '.js-add-comment-container',
            noCommentMessage: '.js-no-comment-message',
            editCommentBtn: '.js-btn-edit-comment',
            editCommentContainer: '.js-edit-comment-container',
            editCommentText: '.js-edit-comment-text',
            cancelComment: '.js-cancel-comment',
            sumaryComment: '.js-summary-comment',
            saveComment: '.js-save-comment',
            rateCommentContainer: '.js-rate-comment-container',
            rateFav: '.js-rate-fav',
            rateFavElements: '.js-rate-fav .favoritos',
            commentText: '.js-comment',
            rateSaved: '.js-rate-saved',
            commentSaved: '.js-commment-saved',
            templateContainer: '#js-favorito-comentario-rate-template',
            previewContainer: '.comment-preview'
        };

        this.__favoritoRateCommentDto = { ...favoritoRateCommentDto, elementSelectors: { ...favoritoRateCommentDto.elementSelectors, ...selectors } };

        this.__templateContainer = jquery(this.__favoritoRateCommentDto.elementSelectors.templateContainer);
        this._favoritosService = favoritosService;
        this.__registerEvents();
    }
    /* jshint ignore:end */

    __registerEvents() {

        jquery(this.__favoritoRateCommentDto.elementSelectors.favorito).click((event) => {
            event.preventDefault();
            event.stopPropagation();

            const dataUrl = event.currentTarget.getAttribute('data-href');
            const hasFavorito = event.currentTarget.classList.contains('delfavimg');
            const codigoAnuncio = event.currentTarget.getAttribute('data-codigoAnuncio');
            const realEstateAdId = event.currentTarget.getAttribute('data-realestateadid');

            this._favoritosService.setFavorito(dataUrl, hasFavorito, codigoAnuncio, realEstateAdId)
                .then(({ type, data }) => {
                    // TODO aquí se deberia hacer todo lo de interacción con la interfaz, cambio de clases etc
                    this.showHideFavIcon(event.currentTarget, type);
                    this.showHideAvisameSi(event.currentTarget, type);
                    this.callbackAddRemoveFav(event.currentTarget, type, data);
                })
                .catch((err) => {
                    console.log(err);
                    //TODO redirect to login page
                });
        });

        jquery(this.__favoritoRateCommentDto.elementSelectors.rateFavElements).click((e) => {
            e.preventDefault();
            e.stopPropagation();
            const element = jquery(e.currentTarget);
            const rateCommentContainer = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
            const rate = jquery(e.currentTarget).attr('data-valoracion');
            this.__callbackClickRateFav(rate, rateCommentContainer);
        });

        jquery(this.__favoritoRateCommentDto.elementSelectors.addComment).click((e) => {
            e.preventDefault();
            e.stopPropagation();
            const element = jquery(e.currentTarget);
            const rateCommentContainer = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
            const noCommentMessage = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.noCommentMessage);
            const editCommentContainer = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentContainer);
            const editCommentText = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentText);
            element.addClass('u-hide-none');
            noCommentMessage.addClass('u-hide-none');
            editCommentContainer.removeClass('u-hide-none');
            editCommentText.focus();
        });

        jquery(this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer + this.__favoritoRateCommentDto.elementSelectors.previewContainer).click((e) => {
            e.preventDefault();
            e.stopPropagation();
            const favButton = document.querySelector(this.__favoritoRateCommentDto.elementSelectors.favorito);
            favButton && favButton.click();
            jquery.publish(HabEvents.EventsEnum.ClickPreviewCommentRate);
            jquery.subscribe(HabEvents.EventsEnum.LoginAjaxOk, () => {
                jquery.publish(HabEvents.EventsEnum.LoginPreviewCommentRateOrigin);
            });
        });

        jquery(this.__favoritoRateCommentDto.elementSelectors.noCommentMessage).click((e) => {
            e.preventDefault();
            e.stopPropagation();
            const element = jquery(e.currentTarget);
            const rateCommentContainer = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
            const addComment = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.addComment);
            const noCommentMessage = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.noCommentMessage);
            const editCommentContainer = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentContainer);
            const editCommentText = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentText);

            addComment.addClass('u-hide-none');
            noCommentMessage.addClass('u-hide-none');
            editCommentContainer.removeClass('u-hide-none');
            editCommentText.focus();
        });



        jquery(this.__favoritoRateCommentDto.elementSelectors.cancelComment).click((e) => {
            e.preventDefault();
            e.stopPropagation();
            const element = jquery(e.currentTarget);
            const rateCommentContainer = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
            const comment = rateCommentContainer.attr('comment');
            const addCommentContainer = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.addCommentContainer);
            const addComment = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.addComment);
            const editCommentContainer = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentContainer);
            const sumaryComment = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.sumaryComment);
            const editCommentText = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentText);
            const noCommentMessage = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.noCommentMessage);

            if (comment) {
                addCommentContainer.addClass('u-hide-none');
                editCommentContainer.addClass('u-hide-none');
                sumaryComment.removeClass('u-hide-none');
                editCommentText.val(comment);
            } else {
                addComment.removeClass('u-hide-none');
                addCommentContainer.removeClass('u-hide-none');
                noCommentMessage.removeClass('u-hide-none');
                editCommentContainer.addClass('u-hide-none');
                sumaryComment.addClass('u-hide-none');
            }

        });

        jquery(this.__favoritoRateCommentDto.elementSelectors.saveComment).click((e) => {
            e.preventDefault();
            e.stopPropagation();
            const element = jquery(e.currentTarget);
            const rateCommentContainer = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
            const editCommentText = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentText);
            const comment = editCommentText.val();
            this.__callbackClickSaveComment(comment, rateCommentContainer);
        });

        jquery(this.__favoritoRateCommentDto.elementSelectors.editCommentBtn).click((e) => {
            e.preventDefault();
            e.stopPropagation();
            const element = jquery(e.currentTarget);
            const rateCommentContainer = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
            const sumaryComment = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.sumaryComment);
            const editCommentContainer = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentContainer);
            const editCommentText = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentText);
            sumaryComment.addClass('u-hide-none');
            editCommentContainer.removeClass('u-hide-none');
            editCommentText.focus();
        });


        jquery.subscribe(HabEvents.EventsEnum.LoginAjaxOkAfterFavoritoClick, () => {
            this._continueWithFavoritoPending();
        });

    }

    _continueWithFavoritoPending() {
        this._favoritosService.continueWithFavoritoPending()
            .then(({ type, data, codigoAnuncio }) => {
                const element = document.getElementById(`js-fav-btn-${codigoAnuncio}`);

                this.showHideFavIcon(element, type);
                this.showHideAvisameSi(element, type);
                this.callbackAddRemoveFav(element, type, data);
            });
    }

    showHideFavIcon(currentTarget, type) {
        const divIcoFav = currentTarget.querySelector('.js-ico-fav');

        if (divIcoFav) {
            if (type === 'add') {
                currentTarget.classList.remove('addfavimg');
                currentTarget.classList.add('delfavimg');
                divIcoFav.classList.remove('ico-fav');
                divIcoFav.classList.add('ico-fav-active');
            } else {
                currentTarget.classList.remove('delfavimg');
                currentTarget.classList.add('addfavimg');
                divIcoFav.classList.remove('ico-fav-active');
                divIcoFav.classList.add('ico-fav');
            }
        }
    }

    showHideAvisameSi(currentTarget, type) {
        const idArticle = 'id'+currentTarget.getAttribute('data-codigoanuncio');
        const notifyBtn = document.querySelector('#'+idArticle+' .js-notify');
        if (notifyBtn) {
            if (type === 'add') {
                notifyBtn.classList.add('list-notify-active');
            } else {
                notifyBtn.classList.remove('list-notify-active');
            }
        }
    }

    callbackAddRemoveFav(elementDom, type, data) {

        const element = jquery(elementDom);
        const container = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.itemContainer);
        let rateCommentContainer;

        if (this.__favoritoRateCommentDto.useTemplate && type === 'add') {
            rateCommentContainer = this.__templateContainer.clone(true).attr('id', '');
            container.append(rateCommentContainer);

        } else {
            rateCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
        }

        const editCommentText = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.editCommentText);
        const addCommentContainer = this.__findElement(rateCommentContainer, this.__favoritoRateCommentDto.elementSelectors.addCommentContainer);
        

        if (type === 'add') {
            rateCommentContainer.attr('data-id-reg', data.id);
            rateCommentContainer.attr('data-rate', data.valoracion);
            rateCommentContainer.attr('data-comment', data.opinion);
            rateCommentContainer.removeClass('u-hide-none');
            this.__initRate(rateCommentContainer);
            this.__initComment(rateCommentContainer);

        } else {
            editCommentText.val('');
            rateCommentContainer.remove();
            addCommentContainer.addClass('u-hide-none');
        }
    }

    __initRate(container) {
        const rate = container.attr('data-rate');

        if (rate) {
            const rateFav = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.rateFav);
            rateFav.removeClass('rated-0');
            rateFav.addClass('rated-' + rate);
        }
    }

    __initComment(container) {
        const comment = container.attr('data-comment');
        const commentText = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.commentText);
        const editCommentText = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.editCommentText);
        const addCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.addCommentContainer);
        const sumaryComment = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.sumaryComment);

        const noCommentMessage = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.noCommentMessage);
        const addComment = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.addComment);
        const editCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.editCommentContainer);

        if (comment) {
            commentText.text(comment);
            editCommentText.val(comment);
            addCommentContainer.addClass('u-hide-none');
            sumaryComment.removeClass('u-hide-none');
        } else {
            container.removeClass('u-hide-none');
            addCommentContainer.removeClass('u-hide-none');
            noCommentMessage.removeClass('u-hide-none');
            addComment.removeClass('u-hide-none');
            sumaryComment.addClass('u-hide-none');
        }

        editCommentContainer.addClass('u-hide-none');
    }

    __callbackClickRateFav(rate, elementDom) {
        const element = jquery(elementDom);
        const container = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.itemContainer);
        const rateCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
        const idReg = rateCommentContainer.attr('data-id-reg');
        const previousRate = rateCommentContainer.attr('data-rate');

        if (previousRate !== rate) {
            const puntuacion = parseInt(rate);

            if (puntuacion > 0 && puntuacion < 6) {
                const rateFav = this.__findElement(elementDom, this.__favoritoRateCommentDto.elementSelectors.rateFav);

                rateFav.removeClass('rated-' + previousRate);
                rateFav.addClass('rated-' + rate);
                rateCommentContainer.attr('data-rate', rate);

                this._favoritosService.saveRate(idReg, rate)
                    .then(() => { this.__callbackSaveRate(elementDom); })
                    .catch(() => { this.__callbackErrorSaveRate(); });

            }
        }
    }

    __callbackSaveRate(elementDom) {

        const rateSaved = this.__findElement(elementDom, this.__favoritoRateCommentDto.elementSelectors.rateSaved);

        rateSaved.removeClass('u-hide-none');

        setTimeout(() => {
            rateSaved.addClass('u-hide-none');
        }, 2000);
    }

    __callbackErrorSaveRate() {
        //TODO Implementar mensaje de error en caso de que no se haya podido guardar la puntuación
    }

    __callbackClickSaveComment(comment, elementDom) {

        const element = jquery(elementDom);
        const container = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.itemContainer);
        const rateCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);

        const previousComment = rateCommentContainer.attr('data-comment');
        const idReg = rateCommentContainer.attr('data-id-reg');

        if (previousComment !== comment && comment.length <= 500) {
            rateCommentContainer.attr('data-comment', comment);

            this._favoritosService.saveComment(idReg, comment)
                .then(() => { this.__callbackSaveComment(elementDom); })
                .catch(() => { this.__callbackErrorSaveComment(); });

        } else {
            this.__callbackSaveComment(elementDom);
        }
    }

    __callbackSaveComment(elementDom) {
        const element = jquery(elementDom);
        const container = this.__findContainer(element, this.__favoritoRateCommentDto.elementSelectors.itemContainer);
        const rateCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.rateCommentContainer);
        const editCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.editCommentContainer);
        const commentSaved = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.commentSaved);
        const addCommentContainer = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.addCommentContainer);
        const noCommentMessage = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.noCommentMessage);
        const addComment = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.addComment);
        const sumaryComment = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.sumaryComment);
        const commentText = this.__findElement(container, this.__favoritoRateCommentDto.elementSelectors.commentText);
        const comment = rateCommentContainer.attr('data-comment');

        editCommentContainer.addClass('u-hide-none');
        commentSaved.removeClass('u-hide-none');

        setTimeout(() => {
            commentSaved.addClass('u-hide-none');
        }, 2000);

        if (comment.length === 0) {
            addCommentContainer.removeClass('u-hide-none');
            noCommentMessage.removeClass('u-hide-none');
            addComment.removeClass('u-hide-none');
            sumaryComment.addClass('u-hide-none');
        } else {
            commentText.text(comment);
            addCommentContainer.addClass('u-hide-none');
            sumaryComment.removeClass('u-hide-none');
        }
    }

    __callbackErrorSaveComment() {
        //TODO Implementar mensaje de error en caso de que no se haya podido guardar el comentario
    }


    __findElement(container, selector) {
        return container.find(selector);
    }

    __findContainer(element, selector) {
        return element.closest(selector);
    }


   

}

export default FavoritosRateCommentDesktopUI;